import Queue from '@/lib/script/queue';
export default new Queue();